/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    // --- AFFILIES ---
    // Récupérer les statistiques des affiliés
    getStats: async () => await exeRequest("/admin/affiliates/stats", "GET"),

    // Liste des affiliés
    getAffiliates: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/affiliates${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Détail d'un affilié
    getAffiliateById: async (id) => await exeRequest(`/admin/affiliates/${id}`, "GET"),

    // Créer un affilié
    createAffiliate: async (data) => await exeRequest("/admin/affiliates", "POST", data),

    // Modifier un affilié
    updateAffiliate: async (id, data) => await exeRequest(`/admin/affiliates/${id}`, "PUT", data),

    // Approuver un affilié
    approveAffiliate: async (id) => await exeRequest(`/admin/affiliates/${id}/approve`, "PATCH"),

    // Suspendre un affilié
    suspendAffiliate: async (id, reason) => await exeRequest(`/admin/affiliates/${id}/suspend`, "PATCH", { reason }),

    // Réactiver un affilié
    reactivateAffiliate: async (id) => await exeRequest(`/admin/affiliates/${id}/reactivate`, "PATCH"),

    // Supprimer un affilié
    deleteAffiliate: async (id) => await exeRequest(`/admin/affiliates/${id}`, "DELETE"),

    // Liste des chauffeurs disponibles pour liaison
    getAvailableDriversForAffiliate: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/affiliates/available-drivers${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Lier un chauffeur à un affilié
    linkDriverToAffiliate: async (affiliateId, driverId) =>
        await exeRequest(`/admin/affiliates/${affiliateId}/link-driver`, "POST", { driverId }),

    // Délier un chauffeur d'un affilié
    unlinkDriverFromAffiliate: async (affiliateId, driverId) =>
        await exeRequest(`/admin/affiliates/${affiliateId}/unlink-driver/${driverId}`, "DELETE"),

    // Créer un nouveau chauffeur pour un affilié
    createDriverForAffiliate: async (affiliateId, driverData) =>
        await exeRequest(`/admin/affiliates/${affiliateId}/create-driver`, "POST", driverData),

    // --- CANDIDATURES ---
    // Liste des candidatures
    getApplications: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/affiliate-applications${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Détail d'une candidature
    getApplicationById: async (id) => await exeRequest(`/admin/affiliate-applications/${id}`, "GET"),

    // Approuver une candidature
    approveApplication: async (id) => await exeRequest(`/admin/affiliate-applications/${id}/approve`, "PATCH"),

    // Rejeter une candidature
    rejectApplication: async (id, reason) => await exeRequest(`/admin/affiliate-applications/${id}/reject`, "PATCH", { reason }),

    // Supprimer une candidature
    deleteApplication: async (id) => await exeRequest(`/admin/affiliate-applications/${id}`, "DELETE"),

    // --- COMMISSIONS ---
    // Liste des commissions
    getCommissions: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/affiliate-commissions${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Detail d'une commission
    getCommissionById: async (id) => await exeRequest(`/admin/affiliate-commissions/${id}`, "GET"),

    // Commissions par bénéficiaire (type + ID)
    getCommissionsByBeneficiary: async (type, beneficiaryId) =>
        await exeRequest(`/admin/affiliate-commissions/beneficiary/${type}/${beneficiaryId}`, "GET"),

    // Detail des commissions d'un chauffeur pour un beneficiaire
    getDriverCommissionDetails: async (commissionId, driverId) =>
        await exeRequest(`/admin/affiliate-commissions/${commissionId}/driver/${driverId}`, "GET"),

    // Approuver une commission
    approveCommission: async (id) => await exeRequest(`/admin/affiliate-commissions/${id}/approve`, "PATCH"),

    // Marquer une commission comme payée
    payCommission: async (id, paymentReference) => await exeRequest(`/admin/affiliate-commissions/${id}/pay`, "PATCH", { paymentReference }),

    // Annuler une commission
    cancelCommission: async (id, reason) => await exeRequest(`/admin/affiliate-commissions/${id}/cancel`, "PATCH", { reason }),

    // Supprimer une commission
    deleteCommission: async (id) => await exeRequest(`/admin/affiliate-commissions/${id}`, "DELETE"),

    // Générer les commissions ambassadeur manquantes
    generateAmbassadorCommissions: async () => await exeRequest(`/admin/affiliate-commissions/generate-ambassador-commissions`, "POST"),

    // Migration complète: Générer toutes les commissions manquantes
    generateMissingCommissions: async () => await exeRequest(`/admin/affiliate-commissions/generate-missing-commissions`, "POST"),

    // --- REVENUS ---
    // Liste des revenus par bénéficiaire (affiliés + ambassadeurs)
    getRevenueSummaries: async (params = {}) => {
        // Nettoyer les paramètres undefined/null
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/revenues${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Détails des revenus d'un bénéficiaire
    getRevenueDetails: async (type, id) => await exeRequest(`/admin/revenues/${type}/${id}`, "GET"),

    // Mettre à jour le paiement d'un chauffeur (référence Wave)
    updateDriverPayment: async (progressId, data) => await exeRequest(`/admin/driver-progress/${progressId}/payment`, "PUT", data),

    // Récupérer les informations de paiement d'un chauffeur
    getDriverPayment: async (progressId) => await exeRequest(`/admin/driver-progress/${progressId}/payment`, "GET"),

    // --- BONUS RECHARGE JOUR ---
    // Liste des bonus recharge jour groupés par bénéficiaire
    getSameDayRechargeBonuses: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/revenues-bonus-recharge${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Détail des bonus recharge jour pour un bénéficiaire
    getSameDayRechargeBonusDetail: async (type, beneficiaryId) =>
        await exeRequest(`/admin/revenues-bonus-recharge/${type}/${beneficiaryId}`, "GET"),

    // Payer un bonus recharge jour (par commission)
    paySameDayRechargeBonus: async (commissionId, data) =>
        await exeRequest(`/admin/revenues-bonus-recharge/${commissionId}/pay`, "PUT", data),

    // Envoyer un paiement Wave pour un bonus recharge jour (par commission)
    sendBonusRechargeWavePayout: async (data) =>
        await exeRequest(`/admin/wave-payout/send-bonus-recharge`, "POST", data),

    // Payer TOUS les bonus recharge jour en attente d'un bénéficiaire
    payAllSameDayRechargeBonuses: async (data) =>
        await exeRequest(`/admin/revenues-bonus-recharge/pay-all`, "POST", data),

    // Envoyer un paiement Wave pour TOUS les bonus recharge jour en attente d'un bénéficiaire
    sendBonusRechargeWavePayoutAll: async (data) =>
        await exeRequest(`/admin/wave-payout/send-bonus-recharge-all`, "POST", data),

    // --- RÉTENTIONS MENSUELLES ---
    // Liste des rétentions mensuelles groupées par bénéficiaire
    getMonthlyRetentionsList: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/revenues-monthly-retentions${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Détail des rétentions mensuelles pour un bénéficiaire
    getMonthlyRetentionDetail: async (type, beneficiaryId, params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/revenues-monthly-retentions/${type}/${beneficiaryId}${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Payer une rétention mensuelle (par période) - saisie manuelle
    payMonthlyRetention: async (data) =>
        await exeRequest(`/admin/revenues-monthly-retentions/pay`, "PUT", data),

    // Recalculer les rétentions mensuelles pour une période (va chercher dans Yandex)
    recalculateMonthlyRetentions: async (period) =>
        await exeRequest(`/admin/revenues-monthly-retentions/recalculate`, "POST", { period }),

    // Envoyer un paiement Wave pour une rétention mensuelle (par période)
    sendMonthlyRetentionWavePayout: async (data) =>
        await exeRequest(`/admin/wave-payout/send-monthly-retention`, "POST", data),

    // --- COMMISSION 130H MENSUEL ---
    // Liste des bénéficiaires avec stats 130h mensuelles
    get130hBeneficiaries: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/commissions-130h${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Détail d'un bénéficiaire avec progression 130h de ses chauffeurs
    get130hBeneficiaryDetail: async (type, beneficiaryId, params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/commissions-130h/${type}/${beneficiaryId}${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Snapshot 130h - snapshote les heures des chauffeurs pour une période
    snapshot130hHours: async (period) =>
        await exeRequest(`/admin/commissions-130h/snapshot`, "POST", { period }),

    // Payer une commission 130h pour un chauffeur (saisie manuelle)
    pay130hCommission: async (data) => {
        return await exeRequest(`/admin/commissions-130h/pay`, "POST", data);
    },

    // Envoyer un paiement Wave pour une commission 130h
    send130hWavePayout: async (data) =>
        await exeRequest(`/admin/wave-payout/send-130h`, "POST", data),

    // --- ÉTAT DES PAIEMENTS ---
    // Liste agrégée des affiliés et ambassadeurs avec leur statut de paiement
    getPaymentStatus: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await exeRequest(`/admin/payment-status${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // --- WAVE PAYOUT (Décaissements) ---
    // Envoyer un paiement Wave à un affilié ou ambassadeur
    sendWavePayout: async (data) => await exeRequest(`/admin/wave-payout/send`, "POST", data),

    // Récupérer le solde Wave Business
    getWaveBalance: async () => await exeRequest(`/admin/wave-payout/balance`, "GET"),

    // Récupérer les détails d'un payout
    getWavePayoutDetails: async (payoutId) => await exeRequest(`/admin/wave-payout/${payoutId}`, "GET"),
};
